/**
 * Max candidates in one anonymous-CV bundle. Mirrors the backend contract
 * (`CV_BUNDLE_CAP` in `anonymization/candidate-cv.ts`, enforced by the request
 * schemas) — the two must move together or the UI lets users build a selection
 * the API rejects with a 400.
 *
 * Lives here rather than in a single feature's hook: the talent pool, the
 * active search and the ATS all cap their selection by it.
 */
export const MAX_CV_SELECTION = 20;

/**
 * Applicants above which the ATS report keeps only the top-N by confidence
 * score. Mirrors `ATS_REPORT_CAP` in the backend's `report-endpoint-service.ts`
 * — the confirm dialog quotes this number, so a drift would lie to the user.
 */
export const REPORT_APPLICANT_CAP = 50;
